import { ISection, IMeetingTime, ISectionTime } from '../../../interfaces/scheduler_interfaces';
import { IQuery } from 'core-ts-types';
import { ORMMediator } from 'utility-ts-orm';
import * as _4 from 'lodash4';
import { ISectionsDatasource } from '../../../views/sections/datasources/sections_datasource';
import { SectionDetailsModel } from '../models/section_detail_model';
import { SectionInfoServant } from '../../../views/sections/servants/section_info_servant';
import { MeetingTimeServant } from '../../meeting_times/servants/meeting_time_servant';
export class SectionDetailsQuery implements IQuery {
  private _result: {
    section: ISection;
    meeting_times: IMeetingTime[];
    classDuration: string;
  };

  constructor(
    private ngSectionDetailsModel: SectionDetailsModel,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngSectionInfoServant: SectionInfoServant,
    private ngMeetingTimeServant: MeetingTimeServant
  ) {
    ORMMediator.registerQuery(this, ngSectionDetailsModel, ngSectionsDatasource);
  }
  run() {
    const selectedSection = this.ngSectionDetailsModel.read();
    const section = _4.find(this.ngSectionsDatasource.metasource().derived(), { id: selectedSection.id });
    const meeting_times: IMeetingTime[] = [];

    _4.each(_4.get(section, '_section_times'), (sectionTime: ISectionTime) => {
      const fromDate: string = _4.get(sectionTime, 'from_dt') || _4.get(section, 'class_start_dt', '');
      const toDate: string = _4.get(sectionTime, 'to_dt') || _4.get(section, 'class_end_dt', '');
      const dateRange = this.ngSectionInfoServant.convertDateToRange(fromDate, toDate);
      const location = `${_4.get(sectionTime, '_location.campus_name')} |
      ${_4.get(sectionTime, '_location.name')}`;
      const startTime = sectionTime.from_tm ? moment(sectionTime.from_tm, 'HH:mm:ss').format('h:mm a') : 'TBD';
      const endTime = sectionTime.to_tm ? moment(sectionTime.to_tm, 'HH:mm:ss').format('h:mm a') : 'TBD';
      const day =
        sectionTime.day_of_week === 8
          ? 'TBD'
          : sectionTime.day_of_week === 7
          ? 'Sat'
          : moment().weekday(sectionTime.day_of_week).format('ddd');
      const duration = this.ngMeetingTimeServant.dateDifferenceInWeeksOrDays(fromDate, toDate);
      const meetingTimesOjb: IMeetingTime = {
        dateRange: `${dateRange}, ${duration}`,
        day,
        time: `${startTime} - ${endTime}`,
        instructor: _4.get(section, 'instructor_name', ''),
        location
      };

      meeting_times.push(meetingTimesOjb);
    });

    const classDuration = `${this.ngSectionInfoServant.convertDateToRange(
      _4.get(section, 'class_start_dt'),
      _4.get(section, 'class_end_dt')
    )}, ${this.ngMeetingTimeServant.dateDifferenceInWeeksOrDays(
      _4.get(section, 'class_start_dt'),
      _4.get(section, 'class_end_dt')
    )}`;

    this._result = {
      section,
      meeting_times,
      classDuration
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngSectionDetailsQuery', SectionDetailsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_details/queries/section_details_query.ts